import { graphql } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

const RefreshFeedCollection = graphql(/* GraphQL */ `
  mutation RefreshFeedCollection($input: RefreshFeedCollectionInput!) {
    refreshFeedCollection(input: $input) {
      __typename
      ... on FeedCollectionActionSuccess {
        __typename
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useRefreshFeedCollection = () =>
  useTypedMutation(
    RefreshFeedCollection,
    (data) => data.refreshFeedCollection,
    {
      successTypename: 'FeedCollectionActionSuccess',
      refetchQueries: ['GetFeedItems', 'GetCollectionListDetails'],
    },
  )
